// Tag.tsx — Componente de etiqueta de sección
// CONCEPTO: FC (Function Component) con props simples
// Para componentes pequeños y puramente visuales, las props son mínimas.
// No necesita estado ni efectos — es un "pure component" o "dumb component".

import styles from './Tag.module.css';

type TagVariant = 'cyan' | 'purple' | 'green' | 'amber';

interface TagProps {
  children: string;        // Solo texto (no ReactNode) porque es una etiqueta label
  variant?: TagVariant;
  showDot?: boolean;       // Muestra punto pulsante de "activo"
  className?: string;
}

export function Tag({ children, variant = 'cyan', showDot = false, className = '' }: TagProps) {
  return (
    <span className={`${styles.tag} ${styles[variant]} ${className}`}>
      {showDot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
